export default "__VITE_ASSET__CMC$LQu3__"